import DragPanel from "./dragPanel.container";

export default DragPanel;
